export class CostReviewMarginExceptions {
  estimateClassification!: number;
  estimatedMargin!: number;
  estimatedMarginMinimum!: number;
  estimatedMarginVariance!: number;
  reasonForException!: string;
  smOrBgmApprovalRecieved!: number;
  yearlyEscalation!: number;
  yearlyEscalationTarget!: number;
  yearlyEscalationVariance!: number;
  smApprovalReceived!: number;
  escalationCost!: number;
  escalationApplied!: string;
  isReasonForExceptionApplicable!: boolean;
  isEstimateClassificationApplicable!: boolean;
  isBGMApprovalApplicable!: boolean;
  approverEmailId!: string;
}
